import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { LoaderComponent } from '../../../pages/loader/loader.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { ajaxservice } from '../../../../services/ajaxservice';
import { formatDate } from '@angular/common';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { ToastrService } from 'ngx-toastr'
import { ExcelService } from '../../../../services/excelservice';
import moment from 'moment';
import { NgbModal, NgbDate, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { HttpResponse } from '@angular/common/http';
import { assign } from 'lodash';
import { concatAll } from 'rxjs/operators';
import { C } from '@angular/cdk/keycodes';
import { title } from 'process';
declare var $: any;



@Component({
  selector: 'kt-assetstatusreport',
  templateUrl: './assetstatusreport.component.html',
  styleUrls: ['./assetstatusreport.component.scss']
})
export class AssetstatusreportComponent implements OnInit {
  customerid_settings:any={};
  dropdownAssetStatusSettings:any={};
  dropdownFacilityDepartSettings:any ={}
  asset_status_data:any =[];
  assetFiltter:FormGroup;
  LoaderComponentPortal: ComponentPortal<LoaderComponent>;
  @ViewChild('dataTables', { static: true }) table;
  customer_details: any[];
  asset_status_id: any[];
  assetStatusId: any=[];
  overlayRef: OverlayRef;
  facility_department: any;
  facilityDepartId: any=[];
  facility_depart_id: any;
  error: string;
  showAssetHistory: boolean;
  pageLoader: boolean;
  assetStatusReportData: any[];
  currentPage1: number=1;
  totalRecords1: any;
  endRecord1: any;
  startRecord1: any;
  showFilters: boolean;
  search_value: string;
  searchError: string;
  selectedItemsPerPage1: number=50;cusCode: string;
  cusName: string;
  pageFilter: any;
  filteredAsset: any=[];
;
  itemsPerPage1: any=50;
  searchValue1: string='';
  // showAssetHistory:boolean=true;


  constructor(private ajax: ajaxservice, private overlay: Overlay, private calendar: NgbCalendar, private toastr: ToastrService, private chRef: ChangeDetectorRef, 
		private excelservice: ExcelService,private modalService: NgbModal,private sanitizer: DomSanitizer,private fb: FormBuilder) { 
    this.assetFiltter = new FormGroup({
      asset_status_id:new FormControl('',Validators.required),
      customer_name:new FormControl('1',Validators.required),
      FacilityDepart:new FormControl('',Validators.required),  
    });
    this.asset_status_data = [
      {'assetStatusId':'Functional Equipment','assetStatusValue':'Functional'},
      {'assetStatusId':'Non Functional Equipment','assetStatusValue':'Not-Functional'},
      {'assetStatusId':'BER','assetStatusValue':'BER'}
    ];
    
  }

  ngOnInit(): void {
    this.assetFiltter.reset();
    this.cusCode= localStorage.getItem('reg_cust_code')
    this.cusName= localStorage.getItem('reg_cust_name')
    this.assetFiltter.controls['customer_name'].setValue('1');
    this.getFacilityDepartment();
    this.pageFilter =localStorage.getItem('pageFilter');
    if(this.pageFilter==1){   //filter all asset satatus
      this.asset_status_data.filter(assetStatus=>{this.assetStatusId.push(assetStatus.assetStatusId)})
      this.filteredAsset= this.asset_status_data.filter(assetStatus=>this.asset_status_data);
    }else if(this.pageFilter==2){  // filter functional asset
      this.asset_status_data.filter(assetStatus=>{
      if(assetStatus.assetStatusId=='Functional Equipment'){
      this.assetStatusId.push(assetStatus.assetStatusId)
      }
      })
      this.asset_status_data.filter(assetStatus=>{
        if(assetStatus.assetStatusId=='Functional Equipment'){
          this.filteredAsset.push(assetStatus)
        }
      });
    }else{                             // filter non functional asset
      this.asset_status_data.filter(assetStatus=>{
        if(assetStatus.assetStatusId=='Non Functional Equipment'){
        this.assetStatusId.push(assetStatus.assetStatusId)
        }
      })
      this.asset_status_data.filter(assetStatus=>{
        if(assetStatus.assetStatusId=='Non Functional Equipment'){
          this.filteredAsset.push(assetStatus)
        }
      });
    }
    this.assetFiltter.controls['asset_status_id'].setValue(this.filteredAsset);
    this.asset_status_id = this.assetStatusId
    this.customer_details = [
      {'customer_code':this.cusCode,'customer_name':this.cusName}
    ];
    // this.LoaderComponentPortal = new ComponentPortal(LoaderComponent);
    // Facility Department settings
    this.customerid_settings = {
      singleSelection: false,
      idField: 'customer_code',
      textField: 'customer_name',
      selectAllText: 'Select Facility name',
      unSelectAllText: 'UnSelect Facility name',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    // Facility Department settings
    // this.dropdownAssetStatusSettings = {
    //   singleSelection: false,
    //   idField: 'assetStatusId', // Ensure this matches your object structure
    //   textField: 'assetStatusValue', // Ensure this exists
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'Unselect All',
    //   itemsShowLimit: 1,
    //   allowSearchFilter: true
    // }
    // Facility Department settings
    this.dropdownFacilityDepartSettings ={
      singleSelection: false,
      idField: 'device_class_id',
      textField: 'device_class',
      selectAllText: 'Select Facility Department',
      unSelectAllText: 'UnSelect Facility Department',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.dropdownAssetStatusSettings = {
      singleSelection: false,
      idField: 'assetStatusId',
      textField: 'assetStatusValue',
      selectAllText: 'Select Asset Status',
      unSelectAllText: 'UnSelect Asset Status',
      itemsShowLimit: 1,
      allowSearchFilter: true
    }
    setTimeout(() => {
      console.log("eneter")
      this.getAssetStatusReport(1,this.currentPage1, this.itemsPerPage1, this.searchValue1);
    },1000)
  }
  // single select AssetStatus functionality
  onItemSelectAssetStatus(items: any) {
    this.asset_status_id.push(items.assetStatusId);
    this.assetStatusId = this.asset_status_id;
    console.log(this.assetStatusId,'assetStatusId')
  }
  // allselect AssetStatus functionality
  onSelectAllAssetStatus(items: any) {
    this.asset_status_id = [];
    this.asset_status_id =[];
    var isPresent = this.asset_status_id.some(function (el) { return el === items.assetStatusId });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.asset_status_id.push(value.assetStatusId);
      })
    };
    this.assetStatusId = this.asset_status_id;
  }
  // single deselect AssetStatus functionality
  onItemDeSelectAssetStatus(items: any) {
    const index: number = this.asset_status_id.indexOf(items.assetStatusId);
    if (index !== -1) {
      this.asset_status_id.splice(index, 1);
    }
    this.assetStatusId = this.asset_status_id;
  }
  // all deselect AssetStatus functionality
  onItemDeSelectAllAssetStatus(items: any) {
    this.assetStatusId = [];
    this.asset_status_id =[];
  }
   // single select AssetStatus functionality
   onItemSelectFacilityDepart(items: any) {
    (this.facility_department.length!=this.facility_depart_id.length)?this.facility_depart_id=this.facility_depart_id:this.facility_depart_id=[];
    this.facility_depart_id.push(items.device_class_id);
    this.facilityDepartId = this.facility_depart_id;
  }
  // allselect AssetStatus functionality
  onSelectAllFacilityDepart(items: any) {
    this.facility_depart_id = [];
    this.facility_depart_id =[];
    var isPresent = this.facility_depart_id.some(function (el) { return el === items.device_class_id });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.facility_depart_id.push(value.device_class_id);
      })
    };
    this.facilityDepartId = this.facility_depart_id;
  }
  // single deselect AssetStatus functionality
  onItemDeSelectFacilityDepart(items: any) {
    const index: number = this.facility_depart_id.indexOf(items.device_class_id);
    if (index !== -1) {
      this.facility_depart_id.splice(index, 1);
    }
    this.facilityDepartId = this.facility_depart_id;
  }
  // all deselect AssetStatus functionality
  onItemDeSelectAllFacilityDepart(items: any) {
    this.facilityDepartId = [];
    this.facility_depart_id =[];
  }
  // Facility Department
  getFacilityDepartment() {
    var url = 'get_faciility_department/';
    this.ajax.getdata(url).subscribe((result) => {
      if(result.response.response_code == '200' || result.response.response_code == '400') {
        this.facility_department = result.response.data;
        this.facility_department.filter(facilityDepartment=>{this.facilityDepartId.push(facilityDepartment.device_class_id)})
      } else if (result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error');
      } else {
        this.toastr.error("Something went wrong", 'Error');
      }
    }, (err) => {
      console.log(err);                                             //prints if it encounters an error
    });
  }

  search(callValue,value: any, itemsPerPage1: any, page: number) {
    if((this.assetStatusReportData.length!=0 && this.search_value !='')||this.assetStatusReportData.length==0){
      this.showAssetHistory=true;
      const data = {
        'asset_status':[],
        'customer_code':[],
        "length": (itemsPerPage1!=50&&itemsPerPage1!=100&&itemsPerPage1!=150)?'All':itemsPerPage1,
        "start": (itemsPerPage1!=50&&itemsPerPage1!=100&&itemsPerPage1!=150)?50:itemsPerPage1 * (page - 1),
        "draw": page - 1,
        "search_value": value, // Sort direction,
        "sort":"",
        "column":"",
        'facility_department':this.facilityDepartId
        }
    var url = 'facility_assetstatus_report/'                                 //api url
    // if(this.regionId.length!=0 && this.deviceClassId.length!=0 && this.contractId.length!=0){
      this.ajax.postdata(url, data).subscribe((result) => {        // added cus type ,productid location id sowmiya
        if (result.response.response_code == "200" || result.response.response_code == "400") {
          this.assetStatusReportData = result.response.data;                    // storing the api response in the array
          this.totalRecords1 = result.response.pagination.total;
          this.endRecord1 = result.response.pagination.to;
          this.startRecord1 = result.response.pagination.from;
          this.currentPage1 = result.response.pagination.current_page
          setTimeout(() => {
            if ($.fn.dataTable.isDataTable("#normalAssetDatatables")) {
              const table = $('#normalAssetDatatables').DataTable();
              table.clear();               // Clear current data
              table.rows.add(this.assetStatusReportData);          // Add new data
              table.page(this.currentPage1 - 1).draw(false); // Set page index and redraw
            }
            else {         // Initialize DataTable
              this.initializeassetDataTable(page, itemsPerPage1);
            }
          },);
          //  (!this.pagination_flags) ? this.pagination_flags = true :
            // this.showPmsReport = false;
          this.showAssetHistory=false;
          this.pageLoader = true;
          this.chRef.detectChanges();
          this.overlayRef.detach();
        }
        else if (result.response.response_code == "500") {
          this.error = result.response.message;
          this.overlayRef.detach();
        }
        else {
          this.error = "Something Went Wrong";
          this.overlayRef.detach();
        }
      }, (err) => {
        console.log(err);                                                 // prints if it encounters an error
        this.overlayRef.detach();
      });
  }
  else{
    this.searchError = "Please Enter Search Value";
  }
 }
 initializeassetDataTable(page: number, itemsPerPage: any) {
  // this.overlayRef.attach(this.LoaderComponentPortal);
  this.table = $('#normalAssetDatatables').DataTable({
     searching: false, // Enable search functionality
     pagingType: 'full_numbers',
     pageLength: this.selectedItemsPerPage1,
     lengthMenu: [50, 100, 150],
     language: {
       zeroRecords: 'No Data Available',
     },
     scrollY: 400,                  //for individual scroll inside table // sowmiya //feb19-2025
			scrollX: true,
			scroller: true,
     data: this.assetStatusReportData, // Pass the data here
     columns: [
       { data: null, title: '#', render: (data, type, row, meta) => meta.row + 1 }, // Serial number column
      {data: 'facility_nature',title:'Facility Nature',defaultContent:'-'},
      {data: 'facility_type',title: 'Facility Type',defaultContent: '-' },
      {data: 'facility_name',title: 'Facility Name',defaultContent: '-' },
      {data: 'state',title: 'State',defaultContent: '-' },
      {data: 'city',title: 'District',defaultContent: '-' },
      {data: 'town',title: 'Town',defaultContent: '-' },
      {data: 'facility_dept',title: 'Facility Department',defaultContent: '-' },
      {data: 'product',title: 'Product Group',defaultContent: '-' },
      { data: 'barcode', title: 'Barcode', render: (data, type, row) => {
            // Render barcode as a clickable element with tooltip
            return `<span  title="Click to view details">${row.barcode}</span>`;
          }, },
      {data: 'equipment_name',title: 'Equipment Name',defaultContent: '-' },
      {data: 'device_make',title: 'Device Make',defaultContent: '-' },
      {data: 'device_model',title: 'Device Model',defaultContent: '-' },
      {data: 'equipment_serial',title: 'Serial Name',defaultContent: '-' },
      {data: 'contract_type',title: 'Contarct Category',defaultContent: '-' },
      {data: 'asset_status',title: 'Asset Status',defaultContent: '-' },
      // { data: null, title: 'Asset History',  orderable: false, // Disable sorting for this column
      //       render: (data, type, row) => {
      //         return `<button class="reset"  data-id="1"  data-barcode="${row.barcode}">View</button>`;
      //       }
      //   }
     ],
     rowCallback: (row: Node, data: any, index: number) => {
      const htmlRow = row as HTMLElement; // Cast Node to HTMLElement
      const barcodeButton = htmlRow.querySelector('.linkButton') as HTMLElement;
      if (barcodeButton) {
        barcodeButton.addEventListener('click', () => {
          // this.get_barocde_details(data.barcode); // Call Angular method for barcode details
        });
        // barcodeButton.setAttribute('title', 'Click to view details'); // Set tooltip text
      }
      const button = htmlRow.querySelector('.reset') as HTMLElement; // Find the button in the row
      if (button) {
          button.addEventListener('click', () => {
              // this.getAssetHistory(1, data.barcode); // Call your Angular method here
          });
      }
  },
     drawCallback: () => {
       this.updatePaginationNumbers();
     },
   });
   // Handle page changes
   $('#normalAssetDatatables').off('page.dt').on('page.dt', (search: string) => {
     const info = this.table.page.info();
     this.pagechange(info.page + 1, this.selectedItemsPerPage1, search);
   });
   $('#normalAssetDatatables').off('length.dt').on('length.dt', (e: any, settings: any, len: number, search: string) => {
     this.selectedItemsPerPage1 = (len!=100&&len!=150&&len!=50)?50:len;
     this.pagechange(1, len, search);
   });
   $('#normalAssetDatatables_wrapper .dataTables_info').remove();
   $('#normalAssetDatatables_wrapper .dataTables_paginate').remove();
  //  this.overlayRef.detach();

 }
 updatePaginationNumbers() {
   this.startRecord1 = this.currentPage1;
   this.endRecord1 = this.totalRecords1;
 }
 pagechange(page: number, itemsPerPage: any, search: string) {
   this.currentPage1 = page;
   this.itemsPerPage1 = itemsPerPage; // Update the items per page if applicable
   this.getAssetStatusReport(1,page, itemsPerPage, search);
 }
  // get asset status report details
  getAssetStatusReport(callValue,page: number, itemsPerPage1: any, search: string){
    console.log("eneteeeeee",this.cusCode,this.cusName)
    // this.overlayRef.attach(this.LoaderComponentPortal);
    this.assetStatusReportData = [];
    // this.showAssetHistory = true;
    // this.overlayRef.attach(this.LoaderComponentPortal);
    this.pageLoader = false;
    this.showFilters = true;
    // {"asset_status":["Functional Equipment","Non Functional Equipment"],
    //   "facility_department":[],"facility_type":[],"customer_code":["CU0241","CU0001"],
    //   "length":50,"start":0,"draw":0,"search_value":"","sort":"","column":""}
    this.pageFilter=''
    const data = {
      'asset_status':this.assetStatusId,
      'customer_code':[this.cusCode],
      "length": (itemsPerPage1!=50&&itemsPerPage1!=100&&itemsPerPage1!=150)?'All':itemsPerPage1,
      "start": (itemsPerPage1!=50&&itemsPerPage1!=100&&itemsPerPage1!=150)?50:itemsPerPage1 * (page - 1),
      "draw": page - 1,
      "search_value": search || '', // Sort direction,
      "sort":"",
      "column":"",
      'facility_department':this.facilityDepartId
      }
    
    var url = 'facility_assetstatus_report/';                                 //api url
    // if(this.regionId.length!=0 && this.deviceClassId.length!=0 && this.contractId.length!=0){
      this.ajax.postdata(url, data).subscribe((result) => {        // added cus type ,productid location id sowmiya
        if (result.response.response_code == "200" || result.response.response_code == "400") {
          this.assetStatusReportData = result.response.data;                    // storing the api response in the array
          this.totalRecords1 = result.response.pagination.total;
        this.endRecord1 = result.response.pagination.to;
        this.startRecord1 = result.response.pagination.from;
        this.currentPage1 = result.response.pagination.current_page
          // if (result.response.recordsTotal <= 50) {
            setTimeout(() => {
              if($.fn.dataTable.isDataTable("#normalAssetDatatables")) {
                const table = $('#normalAssetDatatables').DataTable();
              table.clear();               // Clear current data
              table.rows.add(this.assetStatusReportData);          // Add new data
              table.page(this.currentPage1 - 1).draw(false); // Set page index and redraw
              // this.overlayRef.detach();
            }
            else {         // Initialize DataTable
              this.initializeassetDataTable(page, 1);
              this.overlayRef.detach();
            }
            }, );
            // (!this.pagination_flags)?this.pagination_flags=true:
            this.showAssetHistory = false;
            this.pageLoader = true;
            this.chRef.detectChanges();
        }
        else if (result.response.response_code == "500") {
          this.error = result.response.message;
          this.overlayRef.detach();
        }
        else {
          this.error = "Something Went Wrong";
          this.overlayRef.detach();
        }
      }, (err) => {
        console.log(err);                                                 // prints if it encounters an error
        this.overlayRef.detach();
      });
  }
  // reset asset report
  reset(){
    this.facilityDepartId=[];
    this.facility_depart_id =[];
    this.assetFiltter.reset();
    this.assetFiltter.controls['customer_name'].setValue("1");
    this.ngOnInit();
    this.search_value = ''; 
    this.chRef.detectChanges()
  }
// export PMS ticket details
exportAsAssetReport(): void {
	setTimeout(() => {
	  this.excelservice.exportAsExcelFile(this.assetStatusReportData, 'Asset_report');
	}, 1000);
  }
}
